import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FieldsAccessService } from 'src/app/core/services/fields-access/fields-access.service';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextareaFieldComponent),
  multi: true,
};

@Component({
  selector: 'app-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrls: ['./textarea-field.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
})
export class TextareaFieldComponent
  implements ControlValueAccessor, AfterViewInit, OnChanges, OnDestroy
{
  @Input() label = '';
  @Input() id = '';
  @Input() name = '';
  @Input() maxlength: number;
  @Input() uppercase = false;
  @Input() formControl: AbstractControl;
  @Input() readonly: boolean;
  @Input() disabled: boolean;
  @Input() disableMaxLengthMessage = false;

  @ViewChild('fieldElement', { static: true, read: ElementRef })
  fieldElement: ElementRef;

  invalid = false;
  touched = false;
  innerVal: string | number;
  $globalAccess = new Subscription();

  constructor(private renderer: Renderer2, private fieldsAccessService: FieldsAccessService) {}

  ngAfterViewInit(): void {
    this.preserveGlobalAccess();
  }

  ngOnChanges() {
    this.disabled = this.disabled || this.formControl?.disabled;
    this.invalid = this.formControl?.invalid;
    this.touched = this.formControl?.touched;
  }

  ngOnDestroy(): void {
    this.$globalAccess.unsubscribe();
  }

  preserveGlobalAccess(): void {
    this.$globalAccess = this.fieldsAccessService.canEdit.subscribe((canEdit) => {
      this.readonly = canEdit ? this.readonly : true;
      this.disabled = canEdit ? this.disabled : true;
    });
  }

  onChangeCb: (_?: any) => void = () => {};

  onTouchedCb: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(): void {
    this.updateValue();
    this.onChangeCb(this.innerVal);
  }

  onBlur(): void {
    this.updateValue();
    this.onTouchedCb();
  }

  getValueOrEmptyStr(val: any): string | number {
    return val === null || val === undefined ? '' : val;
  }

  writeValue(val: any): void {
    const fieldVal = this.getValueOrEmptyStr(val);
    this.renderer.setProperty(this.fieldElement.nativeElement, 'value', fieldVal);
    this.onChange();
  }

  updateValue(): void {
    this.value = this.fieldValue;
  }

  get formattedLabel(): string {
    return this.uppercase ? this.label.toUpperCase() : this.label;
  }

  set value(v: any) {
    this.innerVal = v;
  }

  get fieldValue(): number | string {
    return this.fieldElement.nativeElement.value;
  }
}
